// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__Mh6w-","footerBottom":"Footer_footerBottom__YD7o9","socialIcons":"Footer_socialIcons__YGhEY"};